import React, { useState } from "react";
import Editor from "@monaco-editor/react";

const DualEditorConvert = ({
  inputLang,
  outputLang,
  initialInput,
  convertFn,
}) => {
  const [input, setInput] = useState(initialInput);
  // Placeholder text for empty input
  const placeholderMap = {
    json: '{\n  "key": "value"\n}',
    xml: '<?xml version="1.0" encoding="UTF-8"?>\n<root>\n  <key>value</key>\n</root>',
    yaml: 'key: value',
  };
  const inputPlaceholder = placeholderMap[inputLang] || '';
  const [output, setOutput] = useState("");
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleConvert = () => {
    try {
      const result = convertFn(input);
      setOutput(result);
      setError(null);
    } catch (err) {
      setError(err.message);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(output).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Input Editor */}
      <div>
        <h3 className="text-sm font-semibold mb-2 text-gray-700 dark:text-gray-300">Input</h3>
        <Editor
          height="50vh"
          language={inputLang}
          value={input}
          onChange={(v) => setInput(v)}
          theme="vs-dark"
          options={{
            fontSize: 14,
            automaticLayout: true,
            scrollBeyondLastLine: false,
            wordWrap: "on",
            lineNumbers: "on",
            minimap: { enabled: false },
            folding: true,
            bracketPairColorization: {
              enabled: true,
            },
            suggest: {
              enabled: true,
            },
            quickSuggestions: true,
            formatOnPaste: true,
            formatOnType: true,
            placeholder: !input ? inputPlaceholder : undefined,
          }}
        />
      </div>

      {/* Output Editor with Copy */}
      <div className="relative">
        <h3 className="text-sm font-semibold mb-2 text-gray-700 dark:text-gray-300">Output</h3>
        <div className="relative">
          <Editor
            height="50vh"
            language={outputLang}
            value={output}
            theme="vs-dark"
            options={{
              fontSize: 14,
              readOnly: true,
              automaticLayout: true,
              scrollBeyondLastLine: false,
              wordWrap: "on",
              lineNumbers: "on",
              minimap: { enabled: false },
              folding: true,
            }}
          />
          <button
            onClick={handleCopy}
            className="absolute top-2 right-2 z-10 bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded shadow transition-colors"
            title="Copy output to clipboard (Ctrl+C also works)"
            aria-label="Copy output to clipboard"
          >
            {copied ? "✅ Copied" : "📋 Copy"}
          </button>
        </div>
      </div>

      {/* Convert Button */}
      <div className="col-span-full mt-4 flex justify-center">
        <button
          onClick={handleConvert}
          className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-2 rounded shadow transition-colors"
          title="Convert input to output format"
          aria-label="Convert input to output format"
        >
           Convert
        </button>
      </div>

      {/* Error Feedback */}
      {error && (
        <div className="col-span-full text-center mt-2 text-red-600 bg-red-100 px-4 py-2 rounded text-sm">
          {error}
        </div>
      )}
    </div>
  );
};

export default DualEditorConvert;
